import { render } from "./BoosterNav.vue?vue&type=template&id=78df272d&scoped=true&ts=true"
import script from "./BoosterNav.vue?vue&type=script&lang=ts"
export * from "./BoosterNav.vue?vue&type=script&lang=ts"

import "./BoosterNav.vue?vue&type=style&index=0&id=78df272d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78df272d"]])

export default __exports__